import { render, staticRenderFns } from "./phoneForm.vue?vue&type=template&id=c3b7a732&scoped=true"
import script from "./phoneForm.vue?vue&type=script&lang=js"
export * from "./phoneForm.vue?vue&type=script&lang=js"
import style0 from "./phoneForm.vue?vue&type=style&index=0&id=c3b7a732&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b7a732",
  null
  
)

export default component.exports